import React from 'react'
import styled from 'styled-components'
import { Link, Text, Heading, Box, Container, Button } from 'pcln-design-system'
import { WebPBackgroundImage } from '@pcln/content-tile'

type CreditCardProps = {
  titleText: string | JSX.Element
  bodyText: string | JSX.Element
  buttonText: string
  image: string
  imageWebP: string
  legalText: string | JSX.Element
  buttonLink: string
}

const StyledText = styled(Text)`
  list-style-position: inside;
`

export default function CreditCard({
  titleText,
  bodyText,
  buttonText,
  image,
  imageWebP,
  legalText,
  buttonLink
}: CreditCardProps) {
  return (
    <Box
      py={5}
      color="background.lightest"
      style={{
        borderBottom: '1px solid',
        borderColor: '#d1d6db'
      }}
    >
      <Container maxWidth={1280}>
        <Box textAlign="center" mb={4}>
          <Heading fontWeight="bold" fontSize={4} mb={3} color="text">
            {titleText}
          </Heading>

          <StyledText fontSize={[2, 3]} color="text.light" mb={3}>
            {bodyText}
          </StyledText>

          <Link href={buttonLink}>
            <Button px={5} data-testid="CREDIT_CARD_BUTTON">
              {buttonText}
            </Button>
          </Link>
        </Box>
        <Box mb={4}>
          <Link href={buttonLink}>
            <WebPBackgroundImage
              image={image}
              imageWebP={imageWebP}
              height="240px"
              style={{
                backgroundSize: '380px 240px',
                backgroundColor: 'white'
              }}
              alt="Priceline Rewards Credit Card image"
            />
          </Link>
        </Box>
        <Text textAlign="center" fontSize={1} color="text.light" mb={3}>
          {legalText}
        </Text>
      </Container>
    </Box>
  )
}
